import validation from '../../../../../../modules/Gull/Framework/validation.js';

const stap4 = {

	init() {

		$(document).ready(function() {
			stap4.inhoudPakketChange();
			stap4.toggleGarantieverklaring();
		});

		$('#P790_inhoudPakket').change(stap4.inhoudPakketChange);
		$('.garantieverklaring').change(stap4.toggleGarantieverklaring);
	},

	inhoudPakketChange: function() {

		if ($('#P790_inhoudPakket').val() == 'ZW-Compleet') {
			$('#P790_arbo').val('ja');
			$('#P790_arbo').attr('disabled', true);
			$('#P790_verloning').val('ja');
			$('#P790_verloning').attr('disabled', true);
		}

		if ($('#P790_inhoudPakket').val() == 'ZW-Verzekerd') {
			$('#P790_arbo').val('nee');
			$('#P790_arbo').attr('disabled', true);
			$('#P790_verloning').val('nee');
			$('#P790_verloning').attr('disabled', true);
		}

		if ($('#P790_inhoudPakket').val() == 'ZW-Begeleiding') {
			$('#P790_arbo').val('ja');
			$('#P790_arbo').attr('disabled', true);
			$('#P790_verloning').val('nee');
			$('#P790_verloning').attr('disabled', true);
		}

		if ($('#P790_inhoudPakket').val() == 'ZW-BegeleidingPlus') {
			$('#P790_arbo').val('ja');
			$('#P790_arbo').attr('disabled', true);
			$('#P790_verloning').val('ja');
			$('#P790_verloning').attr('disabled', true);
		} else {
			$('#P790_arbo').closest('.form-group').show();
		}
	},

	// Functie om garantieverklaring te tonen en verbergen
	toggleGarantieverklaring: function() {
		var e = $('.garantieverklaring');
		var b = $('.ingangsdatumEigenrisicodragerschapBestaandeWerkgever');
		var o = $('.vervalDatumGarantieVorigeBank');
		var i = $('.ingangsDatumGarantieNieuweBank');
		var h = $('.naamHuidigeVerzekeraarOfBank');
		b.closest('.form-group').addClass('d-none');
		o.closest('.form-group').addClass('d-none');
		i.closest('.form-group').addClass('d-none');
		h.closest('.form-group').addClass('d-none');
		validation.removeRequired(b);
		validation.removeRequired(o);
		validation.removeRequired(i);
		validation.removeRequired(h);
		if (e.length) {
			if (e.val() == 'bestaande-werkgever-die-eigenrisicodrager-wordt') {
				b.closest('.form-group').removeClass('d-none');
				validation.addRequired(b);
			} else if (e.val() == 'eigenrisicodrager-die-overstapt-naar-bank-of-verzekeraar') {
				o.closest('.form-group').removeClass('d-none');
				validation.addRequired(o);
				i.closest('.form-group').removeClass('d-none');
				validation.addRequired(i);
				h.closest('.form-group').removeClass('d-none');
				validation.addRequired(h);
			}
		}
	}
};


export default stap4;
